import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Globe, AlertTriangle, XCircle, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import { useAddDomain } from '@/hooks/useAddDomain';
import { validateDomain } from '@/lib/domain-services';

function AddDomain() {
  const [newDomain, setNewDomain] = useState('');
  const [validationError, setValidationError] = useState<string | null>(null);

  const { mutate: addDomain, isPending: loading, error } = useAddDomain();
  const addNewDomain = async () => {
    if (!newDomain.trim()) return;
    const validation = validateDomain(newDomain);
    if (!validation.isValid) return setValidationError(validation.error || "Invalid domain");
    setValidationError(null);
    addDomain(newDomain);
  };

  const handleDomainChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewDomain(e.target.value);
    if (validationError) setValidationError(null);
  };

  return (
    <div className="space-y-4">
    <div>
      <Label htmlFor="domain" className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-3 block">
        Your Domain Name
      </Label>
      <div className="relative">
        <Globe className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
        <Input
          id="domain"
          type="text"
          placeholder="Enter your domain (e.g., calls.mybrand.com)"
          value={newDomain}
          onChange={handleDomainChange}
          className={`pl-12 ${
            validationError || error
              ? 'border-red-400 focus:border-red-500' 
              : ''
          }`}
          disabled={loading}
          required
        />
      </div>
      {validationError && (
        <div className="flex items-center space-x-2 mt-2 p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800/30">
          <AlertTriangle className="h-4 w-4 text-red-500" />
          <p className="text-sm text-red-600 dark:text-red-400 font-medium">
            {validationError}
          </p>
        </div>
      )}
      {error && (
        <div className="flex items-center space-x-2 mt-2 p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800/30">
          <XCircle className="h-4 w-4 text-red-500" />
          <p className="text-sm text-red-600 dark:text-red-400 font-medium">
            {error.message}
          </p>
        </div>
      )}
    </div>
    <Button 
      disabled={loading} 
      onClick={addNewDomain}
      size="lg"
    >
      {loading 
        ? (<>  <Loader2 className="mr-2 size-5 animate-spin" />Adding Domain...</>) 
        : (<><Globe className="mr-2 size-5" />Add Domain </>)
      }
    </Button>
  </div>
  )
}

export default AddDomain; 